<template>
  <div class="share-video">
    <loading :active.sync="loading"
             :can-cancel="true"
             :is-full-page="true"></loading>
    <div class="share_pc">
      <div class="share-top">
        <div class="share-title">{{ $t('video.share') + ' ' + $t('video.name') }}</div>
        <div class="close-botton"
             style="cursor:pointer"
             @click="setSharingVideoURL(null)">X</div>
      </div>

      <div class="oneline top-24 full-width">
        <label class="label-text">{{ $t('share.supportedVideoSource') }}</label>
        <div class="support-wrapper">
          <div v-for="(item, index) in supportedSources"
               :key="index"
               class="support-src-item">
            <button class="support-src-botton"
                    @click="openVideoSource(item.url)">
              <img :src="item.img" >
            </button>
          </div>
        </div>
      </div>
      <div class="oneline top-24 full-width">
        <label class="label-text">{{ $t('share.videoURL') }}</label>
        <span v-if="videoURLError"
              class="error-text">({{ $t('text.error') }}: {{ videoURLError }})</span>
        <!-- <b-input v-model="videoURL"
               class="input-control"
        :readonly="sharingVideoURL!==''"></b-input>-->
        <el-input
          v-model="videoURL"
          :placeholder="$t('newTextForm.copyTip')"
          :disabled="sharingVideoURL!==''"
        ></el-input>
      </div>
      <div class="oneline top-24 full-width">
        <label class="label-text">{{ $t('label.category') }}</label>
        <span v-if="categoryError"
              class="error-text">({{ $t('text.error') }}: {{ categoryError }})</span>
        <!-- <b-form-select v-model="category"
                     class="input-control">
        <b-form-select-option value="">({{ $t('text.pleaseSelect') }})</b-form-select-option>
        <b-form-select-option value="tvseries">{{ $t('label.tvseries') }}</b-form-select-option>
        <b-form-select-option value="movie">{{ $t('label.movie') }}</b-form-select-option>
        <b-form-select-option value="entertainment">{{ $t('label.entertainment') }}</b-form-select-option>
        <b-form-select-option value="video">{{ $t('label.video') }}</b-form-select-option>
        </b-form-select>-->
        <div class="half-select">
          <el-select
            v-model="category"
            :placeholder="$t('text.pleaseSelect')"
            @change="selectCategory"
          >
            <el-option
              v-for="item in $t('shareCategory')"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <div
                :class="category==item.value?'el-option-inner el-option-extry':'el-option-inner'"
              >
                {{ item.label }}
                <img
                  v-if="category==item.value"
                  src="../../static/newVersionImgs/language_check.svg"
                  alt
                >
              </div>
            </el-option>
          </el-select>
          <el-select
            v-model="subCategory"
            :disabled="category==''"
            :placeholder="$t('text.pleaseSelect')"
          >
            <el-option
              v-for="item in shareSubCategory"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <div
                :class="subCategory==item.value?'el-option-inner el-option-extry':'el-option-inner'"
              >
                {{ item.label }}
                <img
                  v-if="subCategory==item.value"
                  src="../../static/newVersionImgs/language_check.svg"
                  alt
                >
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="oneline top-24 full-width">
        <label class="label-text">{{ $t('label.soundTrackLanguage') }}</label>
        <span
          v-if="soundTrackError"
          class="error-text"
        >({{ $t('text.error') }}: {{ soundTrackError }})</span>
        <!-- <b-form-select v-model="soundTrackLanguage"
                     class="input-control">
        <b-form-select-option value="">({{ $t('text.pleaseSelect') }})</b-form-select-option>
        <b-form-select-option value="english_soundtrack">{{ $t('language.en') }}</b-form-select-option>
        <b-form-select-option value="mandarin_soundtrack">{{ $t('language.mandarin') }}</b-form-select-option>
        <b-form-select-option value="cantonese_soundtrack">{{ $t('language.cantonese') }}</b-form-select-option>
        <b-form-select-option value="other_language">{{ $t('text.other') }} / {{ $t('text.none') }}</b-form-select-option>
        </b-form-select>-->
        <div>
          <el-select v-model="soundTrackLanguage"
                     :placeholder="$t('text.pleaseSelect')">
            <el-option
              v-for="item in $t('shareSound')"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <div
                :class="soundTrackLanguage==item.value?'el-option-inner el-option-extry':'el-option-inner'"
              >
                {{ item.label }}
                <img
                  v-if="soundTrackLanguage==item.value"
                  src="../../static/newVersionImgs/language_check.svg"
                  alt
                >
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="oneline top-24 full-width">
        <label class="label-text">{{ $t('label.subtitleLanguage') }}</label>
        <span v-if="subtitleError"
              class="error-text">({{ $t('text.error') }}: {{ subtitleError }})</span>
        <!-- <b-form-select v-model="subtitleLanguage"
                     class="input-control">
        <b-form-select-option value="">({{ $t('text.pleaseSelect') }})</b-form-select-option>
        <b-form-select-option value="english_subtitle">{{ $t('language.en') }}</b-form-select-option>
        <b-form-select-option value="simplified_chinese_subtitle">{{ $t('language.sc') }}</b-form-select-option>
        <b-form-select-option value="traditional_chinese_subtitle">{{ $t('language.tc') }}</b-form-select-option>
        <b-form-select-option value="other_language">{{ $t('text.other') }} / {{ $t('text.none') }}</b-form-select-option>
        </b-form-select>-->
        <div>
          <el-select v-model="subtitleLanguage"
                     :placeholder="$t('text.pleaseSelect')">
            <el-option
              v-for="item in $t('shareLanguage')"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <div
                :class="subtitleLanguage==item.value?'el-option-inner el-option-extry':'el-option-inner'"
              >
                {{ item.label }}
                <img
                  v-if="subtitleLanguage==item.value"
                  src="../../static/newVersionImgs/language_check.svg"
                  alt
                >
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="top-40 center bottom-20">
        <div class="submit-button"
             @click="submitSharing()">{{ $t('video.share') }}</div>
      </div>
    </div>
    <div class="share_mobile"
         :style="{height: screenHeight * 1.4 + 'px',background: isShowShareSec ? '' :'url(/static/newVersionImgs/nav_background_sec.svg) no-repeat'}">
      <van-nav-bar
        :border="false"
        class="navBar_setting"
        safe-area-inset-top
        fixed
        @click-left="backPrevPage"
      >
        <template #left>
          <van-icon name="arrow-left"
                    color="#000"
                    size="20"></van-icon>
          <div class="language">{{isShowShareSec ? fromFeature === 'selectCategory' ? $t('share.text1') : fromFeature === 'selectLanguage' ? $t('share.text2') :  $t('share.text3') : ''}}</div>
        </template>
        <!-- <template #right
                  v-if="isShowShareSec">
          <div class="btn_setting">{{$t('home.finsh')}}</div>
        </template> -->
      </van-nav-bar>
      <div class="share_primary"
           v-if="!isShowShareSec">
        <div class="stick">
          <img src="/static/newVersionImgs/stick_share.svg" >
        </div>
        <div class="share_source">
          <div class="share_source_title">{{$t('share.supportedVideoSource')}}</div>
          <div v-for="(item, index) in supportedSources"
               :key="index"
               class="share_source_item">
            <button class="share_source_botton"
                    @click="openVideoSource(item.url)">
              <img :src="item.img" >
            </button>
          </div>
        </div>
        <div class="mobile_video_address">
          <div class="mobile_video_address_title">{{$t('share.videoAddress')}}</div>
          <span
            v-if="videoURLError"
            class="error-text"
          >({{ $t('text.error') }}: {{ videoURLError }})</span>
          <van-field
            v-model="videoURL"
            @blur="getShareUrl"
            :placeholder="$t('newTextForm.copyTip')"
            rows="4"
            type="textarea"
            class="mobile_video_address_ipt"
          ></van-field>
        </div>
        <div class="content_box">
          <van-cell-group :border="false"
                          class="menu_box">
            <van-cell
              is-link
              title
              center
              :border="false"
              size="large"
              :clickable="false"
              class="menu_box_item"
              to="/ShareVideo?from=selectCategory"
              :value="subCategory ? subCategoryLabel : $t('share.selectCategory')"
            >
              <template #icon>
                <img
                  src="/static/newVersionImgs/stick_share_category.svg"
                  style="width:31px;height:26px"
                >
                <span style="margin-left:20px;font-size:14px">{{$t('share.text1')}}</span>
              </template>
            </van-cell>
            <van-cell
              center
              is-link
              title
              :border="false"
              size="large"
              class="menu_box_item"
              to="/ShareVideo?from=selectLanguage"
              :value="soundTrackLanguage ? shareSoundLabel : $t('share.selectLanguage')"
            >
              <template #icon>
                <img
                  src="/static/newVersionImgs/mobile_mine_language.svg"
                  style="width:31px;height:26px"
                >
                <span style="margin-left:20px;font-size:14px">{{$t('share.text2')}}</span>
              </template>
            </van-cell>
            <van-cell
              center
              is-link
              title
              :border="false"
              size="large"
              class="menu_box_item"
              to="/ShareVideo?from=selectSubtitle"
              :value="subtitleLanguage ? shareSubtitleLabel : $t('share.selectSubtitle')"
            >
              <template #icon>
                <img
                  src="/static/newVersionImgs/stick_share_subtitle.svg"
                  style="width:31px;height:26px"
                >
                <span style="margin-left:20px;font-size:14px">{{$t('share.text2')}}</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
        <div :class="{submit_btn:true,submit_btn_disabled:videoURL === '' || category === '' || subCategory === '' || soundTrackLanguage === '' || subtitleLanguage  === '' }"
             @click="videoURL !== '' || category !== '' || subCategory !== '' ||  soundTrackLanguage !== '' || subtitleLanguage !== '' ? submitSharing () : ''">{{$t('share.shareVideo')}}</div>
      </div>
      <div class="share_second"
           v-else>
        <div class="share_second_item"
             v-if="fromFeature === 'selectCategory'">
          <div class="item_container">
            <div class="item_title">
              {{$t('label.tvseries')}}
            </div>
            <div class="item_box">
              <div :class="{item_box_item:true,item_box_item_active:item.isSelected}"
                   v-for="(item,idx) in mobileTVSubcategory"
                   :key="idx"
                   @click="selectFun('category','tvseries',item.value)">
                {{item.label}}
              </div>
            </div>
          </div>
          <div class="item_container">
            <div class="item_title">
              {{$t('label.entertainment')}}
            </div>
            <div class="item_box">
              <div :class="{item_box_item:true,item_box_item_active:item.isSelected}"
                   v-for="(item,idx) in mobileEntSubcategory"
                   :key="idx"
                   @click="selectFun('category','entertainment',item.value)">
                {{item.label}}
              </div>
            </div>
          </div>
          <div class="item_container">
            <div class="item_title">
              {{$t('label.movie')}}
            </div>
            <div class="item_box">
              <div :class="{item_box_item:true,item_box_item_active:item.isSelected}"
                   v-for="(item,idx) in mobileMovieSubcategory"
                   :key="idx"
                   @click="selectFun('category','movie',item.value)">
                {{item.label}}
              </div>
            </div>
          </div>
          <div class="item_container">
            <div class="item_title">
              {{$t('label.video')}}
            </div>
            <div class="item_box">
              <div :class="{item_box_item:true,item_box_item_active:item.isSelected}"
                   v-for="(item,idx) in mobileOthSubcategory"
                   :key="idx"
                   @click="selectFun('category','video',item.value)">
                {{item.label}}
              </div>
            </div>
          </div>
        </div>
        <div class="share_second_item"
             v-else-if="fromFeature === 'selectLanguage'">
          <div class="item_container">
            <div class="item_box">
              <div :class="{item_box_item:true,item_box_item_active:item.isSelected}"
                   v-for="(item,idx) in mobileShareSound"
                   :key="idx"
                   @click="selectFun('language',item.value)">
                {{item.label}}
              </div>
            </div>
          </div>
        </div>
        <div class="share_second_item"
             v-else>
          <div class="item_container">
            <div class="item_box">
              <div :class="{item_box_item:true,item_box_item_active:item.isSelected}"
                   v-for="(item,idx) in mobileShareSubtitle"
                   :key="idx"
                   @click="selectFun('subtitle',item.value)">
                {{item.label}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapGetters, mapActions } from 'vuex'
import {
    parseVideoSrc,
    parseYoutubeVideoID,
    parseBilibiliVideoID,
    parseTencentVideoId,
    parseSuboVideoId,
    parseZdziyuanVideoId
} from '@/utils/common'
import { shareVideo, getUserInfo, getVideo } from '@/utils/api'

const supportedSources = [
    {
        url: 'https://www.youtube.com/',
        img: 'static/images/youtube.png'
    },
    {
        url: 'http://v.qq.com/',
        img: 'static/images/tencent.png'
    },
    {
        url: 'https://www.bilibili.com/',
        img: 'static/images/bilibili.png'
    },
    {
        url: 'http://www.subo988.com/',
        img: 'static/images/subo988.png'
    },
    {
        url: 'http://www.zdziyuan.com/',
        img: 'static/images/zuidaziyuan.png'
    }
]

export default {
    props: ['searchLabel', 'searchAllCategory'],
    data() {
        return {
            isMobileApp: process.env.PLATFORM === 'mobile_app',
            loading: false,
            videoURL: '',
            category: '',
            subCategory: '',
            subCategoryLabel: '',
            shareSoundLabel: '',
            shareSubtitleLabel: '',
            soundTrackLanguage: '',
            subtitleLanguage: '',
            videoURLError: false,
            categoryError: '',
            soundTrackError: '',
            supportedSources: supportedSources,
            subtitleError: '',
            shareSubCategory: [],
            screenHeight: 812,
            isShowNavTitle: false,
            isShowShareSec: false,
            fromFeature: 'selectCategory',
            mobileTVSubcategory: [],
            mobileEntSubcategory: [],
            mobileMovieSubcategory: [],
            mobileOthSubcategory: [],
            mobileShareSound: [],
            mobileShareSubtitle: []
        }
    },
    watch: {
        $route() {
            this.isShowShareSec = !!this.$route.query.from
            this.fromFeature = this.$route.query.from
            window.scrollTo(0, 0)
        }
    },
    mounted() {
        this.isShowShareSec = !!this.$route.query.from
        this.fromFeature = this.$route.query.from
        this.screenHeight = window.screen.height
        this.mobileSubcategoryInit()
        this.checkShareURL()
        this.backToHome()
        if (!this.userInfo && this.$route.name === 'ShareVideo') {
            this.$router.push('/login?login=1&from=home')
        }
        if (document.body.clientWidth < 769 && this.$route.name === 'ShareVideo') {
            this.getShareUrl()
        }
        window.onresize = () => {
            this.setSharingVideoURL(null)
            if (document.body.clientWidth > 768) {
                if (this.$route.name !== 'Home' && this.$route.name !== 'VideoDetail') {
                    this.$router.push('/')
                }
            } else {
                this.$bvModal.hide('aboutModal')
                this.$bvModal.hide('shareLinkModal')
                this.$bvModal.hide('feedbackModal')
                this.$bvModal.hide('dailyRewardModal')
                this.$bvModal.hide('share-video-modal')
            }
        }
    },
    methods: {
        ...mapActions([
            'setSharingVideoURL',
            'setGivePetalVideo',
            'setSharedVideoCount',
            'addActivePoint'
        ]),
        mobileSubcategoryInit() {
            this.mobileTVSubcategory = typeof (this.$t('shareSubCategoryTVseries')) === 'object' ? Object.values(this.$t('shareSubCategoryTVseries')) : this.$t('shareSubCategoryTVseries')
            this.mobileTVSubcategory.map(item => { item.isSelected = false })
            this.mobileMovieSubcategory = typeof (this.$t('shareSubCategoryMovie')) === 'object' ? Object.values(this.$t('shareSubCategoryMovie')) : this.$t('shareSubCategoryMovie')
            this.mobileMovieSubcategory.map(item => { item.isSelected = false })
            this.mobileEntSubcategory = typeof (this.$t('shareSubCategoryEntertainment')) === 'object' ? Object.values(this.$t('shareSubCategoryEntertainment')) : this.$t('shareSubCategoryEntertainment')
            this.mobileEntSubcategory.map(item => { item.isSelected = false })
            this.mobileOthSubcategory = typeof (this.$t('shareSubCategoryOther')) === 'object' ? Object.values(this.$t('shareSubCategoryOther')) : this.$t('shareSubCategoryOther')
            this.mobileOthSubcategory.map(item => { item.isSelected = false })
            this.mobileShareSound = typeof (this.$t('shareSound')) === 'object' ? Object.values(this.$t('shareSound')) : this.$t('shareSound')
            this.mobileShareSound.map(item => { item.isSelected = false })
            this.mobileShareSubtitle = typeof (this.$t('shareLanguage')) === 'object' ? Object.values(this.$t('shareLanguage')) : this.$t('shareLanguage')
            this.mobileShareSubtitle.map(item => { item.isSelected = false })
        },
        selectFun(type, category, subCategory) {
            if (type === 'category') {
                this.mobileTVSubcategory.map(item => { item.isSelected = false })
                this.mobileMovieSubcategory.map(item => { item.isSelected = false })
                this.mobileEntSubcategory.map(item => { item.isSelected = false })
                this.mobileOthSubcategory.map(item => { item.isSelected = false })
                switch (category) {
                case 'tvseries':
                    this.mobileTVSubcategory.map(item => {
                        item.isSelected = item.value === subCategory
                        if (item.isSelected) {
                            this.subCategoryLabel = item.label
                        }
                    })
                    break
                case 'movie':
                    this.mobileMovieSubcategory.map(item => {
                        item.isSelected = item.value === subCategory
                        if (item.isSelected) {
                            this.subCategoryLabel = item.label
                        }
                    })
                    break
                case 'entertainment':
                    this.mobileEntSubcategory.map(item => {
                        item.isSelected = item.value === subCategory
                        if (item.isSelected) {
                            this.subCategoryLabel = item.label
                        }
                    })
                    break
                case 'video':
                    this.mobileOthSubcategory.map(item => {
                        item.isSelected = item.value === subCategory
                        if (item.isSelected) {
                            this.subCategoryLabel = item.label
                        }
                    })
                    break
                default:
                    break
                }
                this.category = category
                this.subCategory = subCategory
            } else if (type === 'language') {
                this.mobileShareSound.map(item => {
                    item.isSelected = item.value === category
                    if (item.isSelected) {
                        this.shareSoundLabel = item.label
                    }
                })
                this.soundTrackLanguage = category
            } else {
                this.mobileShareSubtitle.map(item => {
                    item.isSelected = item.value === category
                    if (item.isSelected) {
                        this.shareSubtitleLabel = item.label
                    }
                })
                this.subtitleLanguage = category
            }
        },
        backPrevPage() {
            this.setSharingVideoURL(null)
            this.$router.go(-1)
        },
        getShareUrl() {
            if (!navigator.clipboard) {
                this.setSharingVideoURL('')
                return
            }
            navigator.clipboard
                .readText()
                .then(videoURL => {
                    let videoId = parseYoutubeVideoID(videoURL)
                    let videoIdBilibili = parseBilibiliVideoID(videoURL)
                    let videoIdTencent = parseTencentVideoId(videoURL)
                    let videoIdSubo = parseSuboVideoId(videoURL)
                    if (videoId) {
                        this.loading = true
                        getVideo(videoId)
                            .then(res => {
                                this.setGivePetalVideo(res.data)
                                this.$toast(this.$t('error.alreadyShared'))
                            })
                            .catch(() => {
                                this.setSharingVideoURL(videoURL)
                                this.checkShareURL()
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    } else if (videoIdBilibili) {
                        this.loading = true
                        getVideo(videoIdBilibili, 'bilibili')
                            .then(res => {
                                this.setGivePetalVideo(res.data)
                                this.$toast(this.$t('error.alreadyShared'))
                            })
                            .catch(() => {
                                this.setSharingVideoURL(videoURL)
                                this.checkShareURL()
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    } else if (videoIdTencent) {
                        this.loading = true
                        getVideo(videoIdTencent, 'tencent')
                            .then(res => {
                                this.setGivePetalVideo(res.data)
                                this.$toast(this.$t('error.alreadyShared'))
                            })
                            .catch(() => {
                                this.setSharingVideoURL(videoURL)
                                this.checkShareURL()
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    } else if (videoIdSubo) {
                        this.loading = true
                        getVideo(videoIdSubo, 'subo')
                            .then(res => {
                                this.setGivePetalVideo(res.data)
                                this.$toast(this.$t('error.alreadyShared'))
                            })
                            .catch(() => {
                                this.setSharingVideoURL(videoURL)
                                this.checkShareURL()
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    } else {
                        this.setSharingVideoURL('')
                    }
                })
                .catch(() => {
                    this.setSharingVideoURL('')
                })
        },
        backToHome() {
            if (
                document.body.clientWidth > 768 &&
        this.$route.name === 'ShareVideo'
            ) {
                this.$router.push('/')
            }
        },
        checkShareURL() {
            if (this.sharingVideoURL) {
                this.videoURL = this.sharingVideoURL
            }
        },
        selectCategory(e) {
            this.subCategory = ''
            switch (e) {
            case 'tvseries':
                this.shareSubCategory = this.$t('shareSubCategoryTVseries')
                break
            case 'movie':
                this.shareSubCategory = this.$t('shareSubCategoryMovie')
                break
            case 'entertainment':
                this.shareSubCategory = this.$t('shareSubCategoryEntertainment')
                break
            case 'video':
                this.shareSubCategory = this.$t('shareSubCategoryOther')
                break
            default:
                break
            }
        },
        submitSharing() {
            if (!this.userInfo) {
                alert(this.$t('video.notLogin'))
                return
            }
            const videoSrc = parseVideoSrc(this.videoURL)
            let videoId = ''
            if (videoSrc === 'youtube') {
                videoId = parseYoutubeVideoID(this.videoURL, this.category)
            } else if (videoSrc === 'bilibili') {
                videoId = parseBilibiliVideoID(this.videoURL, this.category)
            } else if (videoSrc === 'tencent') {
                videoId = parseTencentVideoId(this.videoURL, this.category)
            } else if (videoSrc === 'subo') {
                videoId = parseSuboVideoId(this.videoURL, this.category)
            } else if (videoSrc === 'zdziyuan') {
                videoId = parseZdziyuanVideoId(this.videoURL, this.category)
            } else {
                videoId = false
            }
            // this.$toast('提示文案');)
            this.videoURLError = videoId === false
            if (this.videoURLError) {
                if (videoSrc === 'bilibili') {
                    this.videoURLError = this.$t('share.bilibiliNotSupportSuchShare')
                } else if (videoSrc === 'youtube') {
                    this.videoURLError = this.$t('share.youtubeInvalidUrl')
                } else if (videoSrc === 'tencent') {
                    this.videoURLError = this.$t('share.tencentInvalidUrl')
                } else {
                    return
                }
            }
            if (this.category === '') {
                this.categoryError = this.$t('share.noCategory')
            } else {
                this.categoryError = ''
            }
            if (this.subCategory === '') {
                this.categoryError = this.$t('share.noCategory')
                return
            } else {
                this.categoryError = ''
            }
            if (this.soundTrackLanguage === '') {
                this.soundTrackError = this.$t('share.noLanguage')
            } else {
                this.soundTrackError = ''
            }
            if (this.subtitleLanguage === '') {
                this.subtitleError = this.$t('share.noLanguage')
            } else {
                this.subtitleError = ''
            }
            if (
                this.category !== 'video' &&
        this.category !== 'entertainment' &&
        videoSrc === 'bilibili'
            ) {
                this.categoryError = this.$t('share.bilibiliCategory')
            } else if (
                videoSrc === 'youtube' &&
        this.category === 'tvseries' &&
        !videoId.startsWith('PL')
            ) {
                this.categoryError = this.$t('share.tvsNotPlaylist')
            } else {
                this.categoryError = ''
            }
            if (this.categoryError || this.soundTrackError || this.subtitleError) {
                return
            }
            if (!this.userInfo) {
                alert(this.$t('video.notLogin'))
                return
            }
            const token = localStorage.getItem('user_token')
            let category = this.category
            category += '|' + this.subCategory
            let label = this.soundTrackLanguage
            label += '|' + this.subtitleLanguage
            this.loading = true
            getVideo(videoId, videoSrc)
                .then(res => {
                    this.setGivePetalVideo(res.data)
                    this.$toast(this.$t('error.alreadyShared'))
                })
                .catch(() => {
                    shareVideo(videoId, token, category, label, videoSrc)
                        .then(
                            res => {
                                if (res.data && res.data.status === 'ok') {
                                    if (document.body.clientWidth < 769) {
                                        this.$toast(this.$t('video.shareVideoSucc'))
                                    } else {
                                        alert(this.$t('video.shareVideoSucc'))
                                    }
                                    this.setSharedVideoCount(this.sharedVideoCount + 1)
                                    if (this.sharedVideoCount <= 5) {
                                        this.addActivePoint(1)
                                    }
                                    this.setSharingVideoURL(null)
                                    this.$store.dispatch('getVideos', [
                                        this.searchAllCategory,
                                        this.searchLabel,
                                        1,
                                        12,
                                        false
                                    ])
                                    this.updateUserInfo()
                                } else {
                                    if (document.body.clientWidth < 769) {
                                        this.$toast(this.$t('video.shareVideoFail'))
                                    } else {
                                        alert(
                                            this.$t('video.shareVideoFail') +
                      '(' +
                      res.data.message +
                      ')'
                                        )
                                    }
                                }
                            },
                            respError => {
                                alert(this.$t('video.shareVideoFail') + '(' + respError + ')')
                            }
                        )
                        .finally(() => {
                            this.loading = false
                        })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        updateUserInfo() {
            getUserInfo()
                .then(res => {
                    this.setUserInfo(res.data)
                })
                .catch(error => {
                    console.log(error)
                })
        },
        openVideoSource(url) {
            const target = this.isMobileApp ? '_system' : '_blank'
            window.open(url, target)
        }
    },
    computed: {
        ...mapGetters(['sharingVideoURL', 'userInfo', 'sharedVideoCount'])
    },
    destroyed() {
    // window.onresize = null
    },
    components: {
        Loading
    }
}
</script>
<style scoped lang="scss">
.top-24 {
  margin-top: 24px;
}
.top-40 {
  margin-top: 40px;
}
.lr-20 {
  margin-left: 20px;
  margin-right: 20px;
}
.bottom-20 {
  margin-bottom: 20px;
}
.center {
  text-align: center;
}
.input-control {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #d1d1d1;
}
.label-text {
  font-size: 16px;
  color: #000000;
  line-height: 19px;
}
.support-wrapper {
  display: flex;
  flex-wrap: wrap;
  display: flex;
}
.support-src-item {
  /* float: left; */
  margin: 10px 13px 0 0;
}
.support-src-botton {
  width: 115px;
  height: 43px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px #d1d1d1;
  border-radius: 10px;
  border: 0px;
  line-height: 100%;
}
.support-wrapper button img {
  height: 29px;
}
.share-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.share-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #f06565;
  line-height: 24px;
}
.el-select {
  width: 100%;
}
.half-select {
  display: flex;
  justify-content: space-between;
}
.half-select .el-select {
  width: 47%;
}
>>> .el-input__inner {
  border-radius: 8px;
}
>>> .el-input__inner:active,
>>> .el-input__inner:focus {
  border: 1px solid red !important;
}
.el-option-inner {
  display: flex;
  justify-content: space-between;
}
.el-option-extry {
  color: black;
}
.cancel-button {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  border: none !important;
}
.cancel-button:active {
  border: none !important;
  outline: 0 !important;
  background: transparent !important;
}
.submit-button {
  /* font-size: 20px;
    font-weight: bold;
    color: #4A90E2;
    line-height: 24px;
    border: none; */
  width: 160px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f06565;
  color: white;
  border-radius: 22px;
  margin: auto;
}
.submit-button:active {
  border: none !important;
  outline: 0 !important;
  background: transparent !important;
}
>>> .custom-select {
  /* background: none !important; */
  background: #fff
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/13px 17px;
}
.oneline {
  display: inline-block;
}
.full-width {
  width: 100%;
}
.right {
  float: right;
}
.error-text {
  font-size: 12px;
  margin-left: 5px;
  color: red;
}
>>> .modal-body {
  padding: 0px 55px;
}
>>> .modal-content {
  border-radius: 26px;
}
.share_mobile {
  display: none;
}
@media only screen and (max-width: 768px) {
  .share_pc {
    display: none;
  }
  .share_mobile {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-size: contain;
    background-color: #ffeeee !important;

    .navBar_setting {
      width: 100%;
      background: transparent;

      .language {
        font-size: 18px;
        font-weight: bold;
        margin-left: 10px;
      }

      .btn_setting {
        width: 60px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border-radius: 36px;
        color: #ffffff;
        font-size: 14px;
        background: linear-gradient(left, #f59595, #e03232);
      }
    }

    .share_primary {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .stick {
        width: 100%;
        text-align: center;
        margin-top: 30px;

        img {
          width: 250px;
        }
      }

      .share_source {
        width: 90%;
        height: 240px;
        box-shadow: 0 10px 20px 0 rgba($color: #000000, $alpha: 0.1);
        border-radius: 12px;
        background-color: #fff;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        .share_source_title {
          width: 100%;
          margin-top: 10px;
          font-size: 14px;
        }

        .share_source_item {
          width: 50%;

          .share_source_botton {
            height: 43px;
            background-color: #ffffff;
            box-shadow: 0px 0px 4px 0px #d1d1d1;
            border-radius: 10px;
            border: 0px;
            line-height: 100%;

            img {
              height: 29px;
            }
          }
        }
      }

      .mobile_video_address {
        width: 90%;
        height: 200px;
        box-shadow: 0 10px 20px 0 rgba($color: #000000, $alpha: 0.1);
        border-radius: 12px;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        .mobile_video_address_title {
          width: 100%;
          margin-top: 10px;
          font-size: 14px;
        }

        .mobile_video_address_ipt {
          border: 1px solid #cacaca;
          border-radius: 16px;
          width: 95%;
          margin-top: 20px;
        }
      }

      .content_box {
        width: 90%;
        margin-top: 20px;
        border-radius: 12px;
        background-color: #fff;
        box-shadow: 0 10px 20px 0 rgba($color: #000000, $alpha: 0.1);
        padding: 10px;

        .menu_box {
          background: transparent;

          .menu_box_item {
            background: transparent;
            white-space: nowrap;
          }
        }
      }

      .submit_btn_disabled{
        background: #cccccc !important;
      }

      .submit_btn {
        width: 60%;
        height: 40px;
        border-radius: 40px;
        background: linear-gradient(left, #f59595, #e03232);
        color: #fff;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-top: 50px;
      }
    }

    .share_second{
       width: 100%;
      height: 100%;

      .share_second_item{
        width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;

      .item_container{
        width: 100%;
        display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;

        .item_title{
          font-size: 16px;
          font-weight: bold;
          color: #000000;
          width: 75%;
          text-align: left;
        }

        .item_box{
          width: 90%;
        box-shadow: 0 10px 20px 0 rgba($color: #000000, $alpha: 0.1);
        border-radius: 12px;
        background-color: #fff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 10px;
        padding: 10px;

          .item_box_item{
            height: 28px;
            border: 1px solid #BFBFBF;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            color: #666666;
            margin: 10px;
            padding: 10px;
          }

          .item_box_item_active {
            background:linear-gradient(left, #f59595, #e03232);
            border: 1px solid transparent;
            color: #ffffff;
          }
        }
      }
      }
    }
  }
  >>> .modal-content {
    margin-top: 50%;
  }
  .support-wrapper {
    margin: 0 12px;
  }
  .support-wrapper button {
    height: 30px;
    width: 100px;
    margin: 7px 5px;
  }
  .support-wrapper button img {
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareVideo.vue